module.exports = "<svg viewBox=\"0 0 18 19\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M11.425 15.232a8 8 0 1 1 3.072-2.563l2.917 2.912a2 2 0 0 1-2.828 2.828l-3-3a1.79 1.79 0 0 1-.16-.18zM8 14A6 6 0 1 1 8 2a6 6 0 0 1 0 12z\" fill=\"#FFF\" fill-rule=\"evenodd\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./~/svg-inline-loader!./client/components/Categories/Moving/search.svg
// module id = 1994
// module chunks = 0